import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { syncOutlookCalendars } from "store/actions"

const SyncOutlookConflictsModal = ({
  calendar,
  onClose,
  outlookCalendars,
  syncOutlookCalendars,
  loading,
}) => {
  const [checkboxValues, setCheckboxValues] = useState([])
  useEffect(() => {
    if (outlookCalendars && outlookCalendars?.length > 0) {
      const data = []
      for (let item of outlookCalendars) {
        data.push({
          value: item?.id,
          label: item?.summary,
          checked: !calendar?.outlook_sync_calendars_conflicts?.find(
            x => x?.external_calendar_id === item.id
          )
            ? false
            : true,
        })
      }
      setCheckboxValues(data)
    }
  }, [])

  return (
    <React.Fragment>
      <Row className="d-flex justify-content-center">
        <Col xs="auto" className="pe-0">
          <i className="bx bxs-user-circle font-size-20" />
        </Col>
        <Col xs="auto" className="ps-1">
          <span>{calendar?.outlook_connection.outlook_email}</span>
        </Col>
      </Row>
      <Row className="my-2">
        <h6>Check these calendars for conflicts:</h6>
      </Row>
      {checkboxValues?.map((item, index) => (
        <Row key={index} className="form-check my-1">
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="checkbox"
              name={item?.label}
              checked={item?.checked}
              onChange={event => {
                setCheckboxValues(
                  checkboxValues.map(x =>
                    x.value === item.value
                      ? { ...item, checked: event.target.checked }
                      : x
                  )
                )
              }}
            />
            {item?.label}
          </label>
        </Row>
      ))}
      <Row className="d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="light"
            onClick={onClose}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            loading={loading}
            type="button"
            content="Save"
            onClick={() => {
              syncOutlookCalendars({
                values: {
                  calendar_id: calendar.id,
                  sync_type: 2,
                  type: 2,
                  sync_calendar_ids: checkboxValues
                    .filter(x => x.checked)
                    ?.map(x => x.value),
                },
                callback: onClose,
              })
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.BookingsFeature.loading,
})

const mapDispatchToProps = dispatch => ({
  syncOutlookCalendars: values => dispatch(syncOutlookCalendars(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SyncOutlookConflictsModal)
